export enum MessageLevel {
    ERROR,
    WARNING,
    SUCCESS,
    INFO
}

export enum MessageLayout {
    HORIZONTAL,
    VERTICAL,
}

export class MessageDetails {
    public closed: boolean = false;
    constructor(
        public level: MessageLevel,
        public text: string,
        public translationParams: any = {},
        public icon?: string,
        public showIcon: boolean = true) {
    }
}



// WEBPACK FOOTER //
// ./src/app/notification/message/message.ts